var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoToBtn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.854 9 10 12.854l-.707-.707L11.94 9.5H4.06l2.647 2.646-.707.707L2.146 9 6 5.146l.707.708L4.061 8.5h7.879L9.293 5.854 10 5.146z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 2h6V0h3v2h2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2h2V0h3zM1 14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3H1z",
  clipRule: "evenodd"
})));
export default SvgGoToBtn;